import React, { FC, useContext, useState } from 'react';

import { Button, LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';

import { AppContext } from '../../containers/appContextContainer';
import { useDeleteSoeknad } from '../../hooks/useSoeknadMedlaantaker';
import { useTranslation } from '../../translations';

interface Props {
    soeknadId: string;
}

const UserMessageMedlaantakerActive: FC<Props> = ({ soeknadId }) => {
    const { button, userMessage } = useTranslation();
    const { appNameSpace } = useContext(AppContext);
    const [showModal, setShowModal] = useState<boolean>(true);
    const { mutate: DeleteSoeknad } = useDeleteSoeknad(() => {
        window.location.reload();
        setShowModal(false);
    });

    const onClickLukk = () => {
        const redirectUrl = window.location.origin;
        window.location.replace(redirectUrl);
    };

    const onClickSlettSoeknad = () => {
        DeleteSoeknad({ soeknadId, deleteReason: 'Avbrutt søknad' });
    };

    return (
        <Modal
            id="UserMessageMedlaantakerAktiv"
            title={userMessage.tittleMedlaantakerActive}
            description={userMessage.descriptionMedlaantakerActive}
            appNamespace={appNameSpace}
            setOpen={setShowModal}
            open={showModal}
            onClose={() => setShowModal(false)}
        >
            <div className="column justify-content-center margin-top-extra-large">
                <div className="row row-gap">
                    <Button onClick={onClickLukk}>{button.lukk}</Button>
                    <LinkButton
                        data-track-id="kreditt-boliglaan-soeknad-medlaantaker-aktiv-modal"
                        data-track-linkname="slett-soeknad"
                        icon={IconTypes.SLETT_36}
                        style={{ textAlign: 'center' }}
                        onClick={onClickSlettSoeknad}
                    >
                        {button.slettSoeknad}
                    </LinkButton>
                </div>
            </div>
        </Modal>
    );
};

export default UserMessageMedlaantakerActive;
